(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oh-collection-pagination"] && !Shopify.designMode) return;
  try {
    class OhCollectionLoadmore extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.grid = document.getElementById(this.dataset.grid);
      this.countEl = this.querySelector('.oh-collection-pagination__count');
      if (this.link) this.link.addEventListener('click', this.loadMore.bind(this));
    }

    async loadMore(event) {
      event.preventDefault();
      const url = this.link.href;
      this.link.setAttribute('aria-busy', 'true');
      const response = await fetch(url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      // Le rendu serveur pour cette URL ne contient que les produits de
      // CETTE page (voir main-collection-product-grid.liquid, qui boucle
      // sur collection.products à l'intérieur du paginate — jamais plafonné,
      // quelle que soit la taille de la collection). On les ajoute donc à
      // la grille existante au lieu de la remplacer, pour reconstruire le
      // cumul côté client au fil des clics.
      const newItems = doc.getElementById(this.grid.id)?.children || [];
      this.grid.append(...newItems);

      history.pushState({}, '', url);

      const shown = this.grid.children.length;
      this.countEl.textContent = `${shown} produits affichés sur ${this.dataset.total}`;

      const nextLink = doc.querySelector('.oh-collection-pagination__btn');
      if (nextLink) {
        this.link.href = nextLink.href;
      } else {
        this.link.remove();
      }
      this.link.removeAttribute('aria-busy');
    }
  }
  customElements.define('oh-collection-loadmore', OhCollectionLoadmore);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oh-sticky-buy"] && !Shopify.designMode) return;
  try {
    class OhStickyBuy extends HTMLElement {
    connectedCallback() {
      const target = document.getElementById(this.dataset.target);
      if (!target) return;
      const observer = new IntersectionObserver(
        (entries) => this.classList.toggle('is-visible', !entries[0].isIntersecting),
        { threshold: 0 }
      );
      observer.observe(target);
    }
  }
  customElements.define('oh-sticky-buy', OhStickyBuy);
  } catch(e) { console.error(e); }
})();

})();
